import { render } from "./UpdateThreshold.vue?vue&type=template&id=46e55ee2&scoped=true&ts=true"
import script from "./UpdateThreshold.vue?vue&type=script&lang=ts"
export * from "./UpdateThreshold.vue?vue&type=script&lang=ts"

import "./UpdateThreshold.vue?vue&type=style&index=0&id=46e55ee2&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e55ee2"]])

export default __exports__